// src/pages/Assets.jsx
import React, { useState } from 'react';
import { Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import AssetsList from '../components/assets/AssetsList';
import AssetDetail from '../components/assets/AssetDetail';
import AssetForm from '../components/assets/AssetForm';
import AssetFilters from '../components/assets/AssetFilters';

const Assets = () => {
  const [filters, setFilters] = useState({
    asset_type: '',
    location: '',
    vendor: ''
  });
  const location = useLocation();
//  const navigate = useNavigate();
  
  // Only show filters on the main list view
  const showFilters = location.pathname === '/assets';

  return (
    <div>
      <div className="px-4 py-5 sm:px-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              OT Assets
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Manage all your Operational Technology (OT) assets in your security domain.
            </p>
          </div>
          {showFilters && (
            <Link
              to="/assets/new"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              Add Asset
            </Link>
          )}
        </div>
      </div>
      
      {showFilters && (
        <AssetFilters filters={filters} onChange={setFilters} />
      )}
      
      <Routes>
        <Route index element={<AssetsList filters={filters} />} />
        <Route path=":assetId" element={<AssetDetail />} />
        <Route path="new" element={<AssetForm mode="create" />} />
        <Route path=":assetId/edit" element={<AssetForm mode="edit" />} />
      </Routes>
    </div>
  );
};

export default Assets;
